import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  Paper,
  Button,
  Grid,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  TextField,
  Typography,
} from "@mui/material";
import { PlayArrow } from "@mui/icons-material";
import { useSocket } from "../../core/hooks/useSocket";
import { useDataFetch } from "../../core/hooks/useDataFetch";
import useCookie from "../../core/hooks/useCookie";
import { useAppState } from "../../core/store/contextProvider";
import { AppActions } from "../../core/store/reducers";
import { Config } from "../../config/config";

const ConfigureTrend = () => {
  const [selectedJob, setSelectedJob] = useState("instruments");
  const [isJobRunning, setIsJobRunning] = useState(false);
  const [socketStaging, setSocketStaging] = useState(null);
  const logEndRef = useRef(null);
  const { jobFeedLog, updateStore } = useAppState();
  const { connect, feedData } = useSocket(socketStaging || selectedJob);
  const { callAPI } = useDataFetch();
  const { getToken } = useCookie();

  useEffect(() => {
    if (logEndRef.current) {
      logEndRef.current.scrollTop = logEndRef.current.scrollHeight;
    }
  }, [jobFeedLog]);

  const jobOptions = [{ text: "Refill Instruments", value: "instruments" }];

  useEffect(() => {
    const checkJobStatus = async () => {
      const response = await callAPI(Config.ITradeAPI.checkJobStatus);
      if (response.status && response.data) {
        const { jobName } = response.data;
        if (jobName) {
          setSelectedJob(jobName);
          setSocketStaging(jobName);
          setIsJobRunning(true);
          const profileID = getToken()?.profileID;
          if (profileID) {
            setTimeout(() => connect(profileID), 100);
          }
        } else {
          setSocketStaging(null);
          setIsJobRunning(false);
        }
      }
    };
    checkJobStatus();
  }, []);

  useEffect(() => {
    if (feedData?.status) {
      if (feedData.status === "completed" || feedData.status === "error") {
        setIsJobRunning(false);
      } else if (feedData.status === "inprogress") {
        setIsJobRunning(true);
      }
    }
  }, [feedData?.status]);

  const handleJobChange = (event) => setSelectedJob(event.target.value);

  const handleStartJob = async () => {
    updateStore({ type: AppActions.ClearJobFeedLog });
    setIsJobRunning(true);
    setSocketStaging(selectedJob);
    const profileID = getToken()?.profileID;
    if (profileID) connect(profileID);
    await new Promise((r) => setTimeout(r, 500));
    const response = await callAPI(Config.ITradeAPI.runJob, { jobname: selectedJob });
    if (response.status && response.data?.status === "running") {
      updateStore({ type: AppActions.AppendJobFeedLog, payload: "Job initiated successfully\n" });
    }
  };

  return (
    <Box sx={{ p: 3, height: "calc(100vh - 75px)", display: "flex", flexDirection: "column", overflow: "hidden" }}>
      <Paper elevation={2} sx={{ p: 2, mb: 2, flexShrink: 0 }}>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} sm={6} md={4}>
            <FormControl fullWidth size="small" variant="outlined">
              <InputLabel>Select Job</InputLabel>
              <Select value={selectedJob} onChange={handleJobChange} label="Select Job">
                {jobOptions.map((opt) => (
                  <MenuItem key={opt.value} value={opt.value}>
                    {opt.text}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={2}>
            <Button
              variant="contained"
              color="primary"
              startIcon={<PlayArrow />}
              onClick={handleStartJob}
              disabled={isJobRunning}
              fullWidth
            >
              Start Job
            </Button>
          </Grid>
        </Grid>
      </Paper>

      <Paper elevation={2} sx={{ flex: 1, display: "flex", flexDirection: "column", p: 2, minHeight: 0, overflow: "hidden", height: "100%" }}>
        <Typography variant="h6" sx={{ mb: 2, fontWeight: 600, flexShrink: 0 }}>
          Job Log
        </Typography>
        <Box sx={{ flex: 1, minHeight: 0, display: "flex", flexDirection: "column", overflow: "hidden", height: "100%" }}>
          <TextField
            inputRef={logEndRef}
            multiline
            fullWidth
            value={jobFeedLog}
            placeholder="Job logs will appear here..."
            variant="outlined"
            sx={{
              height: "100%",
              "& .MuiInputBase-root": { height: "100%", alignItems: "flex-start", display: "flex" },
              "& .MuiInputBase-input": { height: "100% !important", overflowY: "auto !important", fontFamily: "monospace", fontSize: "0.875rem", lineHeight: 1.5 },
            }}
            InputProps={{ readOnly: true }}
          />
        </Box>
      </Paper>
    </Box>
  );
};

export default ConfigureTrend;
